(function () {
  const content = document.querySelector(".js-article-content");
  if (!content) return;

  const links = content.querySelectorAll("a[title]");

  links.forEach((link) => {
    const image = link.querySelector("img");
    if (!image) return;

    const title = (link.getAttribute("title") || "").trim();
    if (!title) return;

    // altが空の場合だけtitleを入れる
    if (!image.getAttribute("alt")?.trim()) {
      image.setAttribute("alt", title);
    }
  });
})();